import { render, staticRenderFns } from "./PromotionOrderTable.vue?vue&type=template&id=33d8f9b2"
import script from "./PromotionOrderTable.vue?vue&type=script&lang=js"
export * from "./PromotionOrderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports